export function isUndefinedOrEmpty(x: any) {
  return typeof x === 'undefined' || x === null || x === '';
}
